// Emoji ban — [공통] 00_입력검증표준 v1.2 §4.2.
//
//   "이모지는 전 클래스 불허" (2026-07-10 확정 — 초안의 '설명·본문 허용' 제안 기각).
//   차단 시 인라인 에러로 안내.
//
// The matrix in §4.2 bans emoji for every one of the six text classes
// (NAME · TITLE · DESC · SHORT_BODY · BODY · SEARCH), so the rule is not a
// per-feature concern — it is a property of "any user-authored text field in
// this app". Before SHCT-853~860 the regex lived in three separate copies
// (search-input.ts, notices/utils/validation.ts, PatientRegistrationModal.tsx)
// and eight screens had no check at all; this module is now the single owner
// and those copies re-export from here.
//
// §4.2 lists no RICHTEXT class — 리치텍스트 is carved out by §3 for its LENGTH
// cap only (20,000자), not for the character policy — so the RTE bodies
// (공지 내용 · 약관 본문 · 블록 에디터 텍스트) are covered too, via
// {@link hasEmojiInRichText}.
//
// §4.2 also notes the user-facing wording is not standardised yet ("문구는 §5-⑧
// 후속 시 표준화"). Until it is, every message follows the shipped precedent
// `notices.errors.titleEmoji` — "<필드명>에 이모지는 사용할 수 없습니다."

import { decodeHtmlEntities } from './decode-html-entities';

// Extended_Pictographic covers emoji + surrogate-pair pictographs (the utf8mb4
// range the standard bans). Unicode property escapes need the `u` flag.
const EMOJI_RE = /\p{Extended_Pictographic}/u;

/** True when a plain-text value contains any emoji / pictograph (§4.2). */
export function hasEmoji(text: string | undefined | null): boolean {
  if (!text) return false;
  return EMOJI_RE.test(text);
}

/**
 * Rich-text variant: the WYSIWYG editors persist a pasted emoji either literally
 * or as a numeric character reference (`&#128512;`), and markup sits in between,
 * so testing the raw HTML alone both misses the entity form and could trip on
 * tag/attribute text the user never sees. Strip tags → decode entities → test,
 * matching how `plainTextLength` already derives visible characters elsewhere.
 */
export function hasEmojiInRichText(html: string | undefined | null): boolean {
  if (!html) return false;
  return hasEmoji(decodeHtmlEntities(html.replace(/<[^>]*>/g, ' ')));
}
